<main class="settings-page">
  @if (isLoading) {
    <div class="loading-state" aria-live="polite">
      <mat-spinner diameter="32"></mat-spinner>
      <span>設定を読み込んでいます...</span>
    </div>
  } @else if (dashboard) {
    <header class="page-heading">
      <div>
        <p class="eyebrow">Dashboard Settings</p>
        <h1>{{ dashboard.name }} 設定</h1>
        <p class="page-description">
          月次実績・月次目標のファイル入稿、社員番号、重点強化KeyAction、AI草案用ナレッジを管理します。
        </p>
      </div>
      <div class="role-chip">
        <mat-icon aria-hidden="true">verified_user</mat-icon>
        運用責任者向け
      </div>
    </header>

    <section class="access-note" aria-label="アクセス制限">
      <mat-icon aria-hidden="true">shield</mat-icon>
      <span>
        <strong>アクセス制限：</strong>
        この設定画面は運用責任者（全権管理者・イネーブラー）向けです。
      </span>
    </section>

    <mat-tab-group
      class="settings-tabs"
      animationDuration="0ms"
      preserveContent
    >
      <mat-tab label="月次実績">
        <app-kpi-dashboard-import-tab
          [dashboard]="dashboard"
          [kind]="importKind.Record"
        />
      </mat-tab>
      <mat-tab label="月次目標">
        <app-kpi-org-target-settings [dashboard]="dashboard" />
        <h2 class="individual-target-heading">個人目標（CSV 取込）</h2>
        <app-kpi-dashboard-import-tab
          [dashboard]="dashboard"
          [kind]="importKind.Target"
        />
      </mat-tab>
      <mat-tab label="社員番号">
        <ng-template matTabContent>
          <app-kpi-employee-number-settings [dashboard]="dashboard" />
        </ng-template>
      </mat-tab>
      <mat-tab label="重点強化KA">
        <ng-template matTabContent>
          <app-kpi-key-action-settings [dashboard]="dashboard" />
        </ng-template>
      </mat-tab>
      <mat-tab label="ナレッジ">
        <ng-template matTabContent>
          <app-kpi-knowledge-settings [dashboard]="dashboard" />
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  } @else {
    <section class="empty-state">
      <mat-icon aria-hidden="true">error_outline</mat-icon>
      <p>個人支援ボード設定を表示できません。</p>
    </section>
  }
</main>
